import { render, staticRenderFns } from "./multipleCards.vue?vue&type=template&id=1cc0e504&scoped=true"
import script from "./multipleCards.vue?vue&type=script&lang=js"
export * from "./multipleCards.vue?vue&type=script&lang=js"
import style0 from "./multipleCards.vue?vue&type=style&index=0&id=1cc0e504&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc0e504",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cc0e504')) {
      api.createRecord('1cc0e504', component.options)
    } else {
      api.reload('1cc0e504', component.options)
    }
    module.hot.accept("./multipleCards.vue?vue&type=template&id=1cc0e504&scoped=true", function () {
      api.rerender('1cc0e504', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/pageStrategy/components/multipleCards.vue"
export default component.exports